import React from 'react';
import { Field } from 'redux-form';
import { SearchSelectBox } from 'jbc-front/components/SearchForm';
import { arrowRenderer } from 'jbc-front/components/Form';
import styles from './SelectBoxBonusNames.scss';

class SelectBoxBonusNames extends React.Component {
  render() {
    const { bonusNames } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.BonusGroupsWrapper}>
          <Field name="bonusId" component={SearchSelectBox} options={bonusNames} arrowRenderer={arrowRenderer} />
        </div>
      </div>
    );
  }
}

export default SelectBoxBonusNames;
